import { create } from 'zustand';

type PrV2CommentsPopoverStore = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
};

/**
 * Whether the comments popover in the review tab bar is open. It lives here rather than in the tab
 * bar so that other parts of the page, like the auto-fix row in the sidebar, can open it too.
 */
export const usePrV2CommentsPopoverStore = create<PrV2CommentsPopoverStore>((set) => ({
  isOpen: false,
  setOpen: (isOpen) => set({ isOpen }),
}));
